<template>
  <CCard class="auction-manager-card">
    <CCardHeader>
      <div class="auction-manager-card__header">
        <CInput
          class="auction-manager-card__header-input"
          size="sm"
          placeholder="Search for incoming inventory...."
          :value="$route.query.search"
          @input="onInputSearch"
          @keyup.enter="onInputSearch($event.target.value)"
          @keyup.esc="onInputSearch()"
        />
      </div>
    </CCardHeader>
    <CCardBody color="white" border-color="white">
      <CDataTable
        class="auction-manager__table"
        :items="computedItems"
        :fields="fields"
        :loading="loading"
        @row-clicked="toggleRow"
        ref="table"
      >
        <template #rowId="{item}">
          <td :data-row-id="item.id"></td>
        </template>
        
        <template #createdAt="{item}">
          <td>
            <span>{{convertDate(item.createdAt)}}</span>
          </td>
        </template>
        <template #car="{item}">
          <td>
            <VCarCard class="auction-manager__car" :car="item.car" />
          </td>
        </template>
        <template #marketplace_link="{item}">
          <td>
            <a
              :class="{
                'auction-manager__disabled-link': !item.marketplace_link
              }"
              :href="item.marketplace_link"
              target="blank"
            >
              Marketplace Link
            </a>
          </td>
        </template>
        <template #evbids_link="{item}">
          <td>
            <a
              :class="{ 'auction-manager__disabled-link': !item.evbids_link }"
              :href="item.evbids_link"
              target="blank"
            >
              EV Bids Link
            </a>
          </td>
        </template>
        <template #type="{item}">
          <td class="verification">
            <select
              class="form-control"
              :name="'verification-dropdown marketplace-'+item.id"
              v-model="item.type"
              :id="item.id"
              @change="changeItemType"
            >
              <option value="private party">Private party</option>
              <option value="tax credit">Tax Credit</option>
              <option value="dealer">Dealer</option>
            </select>
          </td>
        </template>
        <template #taxCredit="{item}">
          <td class="verification">
            <select
              class="form-control"
              name="verification-dropdown marketplace"
              v-model="item.taxCredit"
              :id="item.id"
              @change="onTaxCreditChange"
            >
              <option value="true">True</option>
              <option value="false">False</option>
            </select>
          </td>
        </template>
        <template #status="{item}">
          <td class="auction-status">
            <CBadge :color="getColor(item.status)">{{ item.status }}</CBadge>
          </td>
        </template>
        <template #price="{item}">
          <td class="auction-status">
            <span >${{ item.price }}</span>
          </td>
        </template>
        <template #edit-header> </template>
        <template #edit="{item}">
          <td>
            <div class="">
              <CDropdown>
              <template #toggler>
                <CButton class="toggler">
                  <CIcon name="dots" />
                </CButton>
              </template>
              <CDropdownItem class="btn btn-info" @click="editItem(item)">
                Edit
              </CDropdownItem>
              <CDropdownItem class="btn btn-info" @click="onDeleteItem(item)">
                Delete
              </CDropdownItem>
            </CDropdown>
            </div>
            
          </td>
        </template>
      </CDataTable>
    </CCardBody>
    <CCardFooter class="auction-manager-card__footer">
      <VMarketplacePagination
        class="auction-manager-card__footer-pagination"
        :current-page.sync="currentPage"
      />
    </CCardFooter>
  </CCard>
</template>

<script>
import {
  auctionManagerStore,
  createAuctionManagerMixin
} from "@/mixins/auctionsManagerMixin";
import VMarketplacePagination from "@/components/VMarketplacePagination";
import VCarCard from "@/components/AuctionManager/VCarCard";
import { toggleRowClass } from "@/utils/table/toggleRowClass";
import { debounce } from "@/utils/debounce";
import ModalType from "@/utils/dictionaries/modalType";
import {
  getLastCarBid,
  getStatus,
  getStatusColor,
  isReversePriceNotMeet,
  isZeroBids,
  isEndedCar
} from "@/utils/validation/car";
import { CAR_STATUS } from "@/utils/dictionaries/car";
import getTimerFromNowToDate from "@/utils/time/getTimerFromNowToDate";
import { getUserLink } from "@/utils/validation/user";
import URLS from "@/constants/url";
import { CInputCheckbox } from "@coreui/vue";
import api from "@/api/api";
import {
  createCarManagerMixin,
  carManagerStore
} from "@/mixins/carManagerMixin";
const defaultImage =
  "https://media.carsandbids.com/cdn-cgi/image/width=712,height=468,quality=70/da4b9237bacccdf19c0760cab7aec4a8359010b0/photos/3ja0R3IXGI2-2.lmFYrFQis.jpg?t=160323755351";
  import moment from 'moment'
  import {
  createMarketplaceMixin,
  marketplaceStore,
} from "@/mixins/marketplaceMixin";
import { getAuctionLink } from "@/utils/helper";
export default {
  name: "ListingOver26",
  components: {
    VCarCard,
    VMarketplacePagination
  },

  mixins: [createAuctionManagerMixin(), createCarManagerMixin(), createMarketplaceMixin()],

  data() {
    return {
      fields: [
        { key: "rowId", label: "" },
        {
          key: "createdAt",
          label: "Date Added",
          _classes: "auction-verified",
          _style: "min-width: 150px;max-width: 150px"
        },
        {
          key: "car",
          label: "Vehicle Details",
          _style: "min-width: auto;max-width: 300px"
        },
        {
          key: "price",
          label: "Price",
          _classes: "auction-verified",
          _style: "min-width: 120px;max-width: 140px"
        },
        {
          key: "marketplace_id",
          label: "Marketplace ID",
          _style: "min-width: 140px;max-width: 140px;text-align: center;"
        },
        {
          key: "marketplace_link",
          label: "Marketplace Link",
          _style: "min-width: 120px;max-width: 300px"
        },
        {
          key: "type",
          label: "Type",
          _classes: "auction-kind",
          _style: "min-width: 125px;max-width: 125px;text-align: center;"
        },
        { key: 'edit', label: '', _style: 'min-width: 125px;max-width: 62px' },
      ],
      checkedRows: [],
      currentPage: 1,
      loading: false,
      searchFn: () => {},
      getUserLink: getUserLink,
    };
  },

  async created() {
    await this.loadData();

    this.searchFn = debounce.call(
      this,
      async term => {
        const query = {
          ...this.$route.query,
          search: term
        };

        if (!query.search && query.skip) {
          query.skip = 0;
        }

        this.$router
          .push({
            query
          })
          .catch(() => {});
      },
      200
    );
  },

  watch: {
    isReload(newValue) {
      this.loadData();
    },
    checkedRows(rows) {
      this.checkRows(rows, "auction-manager__row-checked");
    },
    computedItems() {
      this.checkRestartRows();
    },
    $route() {
      this.clearCheckboxes();
      this.loadData();
    }
  },

  computed: {
    isReload() {
      return this[marketplaceStore.getterTypes.GETTER_PAGE_RELOAD];
    },
    externalCar() {
      return this[marketplaceStore.getterTypes.GETTER_DATA];
    },
    externalCarCount() {
      return this[marketplaceStore.getterTypes.GETTER_DATA_COUNT];
    },

    computedItems() {
      return (
        this.externalCar &&
        this.externalCar.map(a => {
          const item = {
            id: a.id,
            car: {
              title: a.title,
              make: a.make,
              model: a.model,
              year: a.year,
              imageUrl: this.findImage(a.images),
              link: a.adUrl,
            },
            vin: a.vin ? a.vin : "",
            price: a.price,
            marketplace_id: a.marketplaceId,
            evbids_link: `${URLS.app}/market-place/${a.id}`,
            marketplace_link: a.adUrl,
            type: a.type,
            taxCredit: a.taxCredit
          };
          // this.checkCarTimer(item) TODO: Make status value from awaiting to In progress
          return item;
        })
      );
    },
    checkedRowsCount() {
      return this.checkedRows.length;
    },
    isChecked() {
      return this.checkedRows
        .map(row => row.id)
        .reduce((acc, val) => {
          acc[val] = true;
          return acc;
        }, {});
    }
  },

  methods: {
    async changeItemType(event){
      try {
        this.loading = true
        const formData = new FormData()
        formData.append("type",event.target.value)
        await this[marketplaceStore.actionTypes.ACTION_UPDATE_MARKETPLACE_CAR]({ carId: event.target.id, formData: formData})
        this.loadData()

      } catch (error) {
        console.log("error in change type", error)      
      }
    },
    async onTaxCreditChange(event){
      try {
        this.loading = true
        const formData = new FormData()
        formData.append("taxCredit",event.target.value)
        await this[marketplaceStore.actionTypes.ACTION_UPDATE_MARKETPLACE_CAR]({ carId: event.target.id, formData: formData})
        this.loadData()
      } catch (error) {
        console.log("error in change type", error)      
      }
      console.log("onTaxCreditChange value", event.target.value)
      console.log("onTaxCreditChange id", event.target.id)
    },
    async changeStatus(status, id){
      this.loading = true;
      let data = {
        status: status,
        vehicleId: id
      }
      let res = await this[marketplaceStore.actionTypes.CHANGE_STATUS]({
        data : data
      });
      setTimeout(() => {
        this.loadData()
      }, 1000)
      console.log("res",res)
    },
    convertDate(date){
      return moment(date).format('ll')
    },
    onTypeChange(item, type){

    },
    onDeleteItem(item) {
      const deleteAction = async () => {
        try {
          await api.delete(`/marketplaces/${item.id}`);
          this.$modals.close(ModalType.ConfirmationModal);
          // this.$router.go();
          this.loadData()
        } catch (error) {
          console.log(error);
        }
      };

      this.$modals.open(ModalType.ConfirmationModal, {
        title: "Deletion",
        body: `Are you sure you want to delete this car?`,
        buttonText: "Delete",
        onClickButton: deleteAction
      });
    },
    openComments(item) {
      return this.$modals.open(ModalType.CommentsModal, {
        ...item,
        disabled: false
      });
    },
    findImage(carImages) {
      if (carImages.length > 0) {
        let url = "";
        url = carImages.find(c => c.mainImage === 1)?.url;
        if (!url) {
          url = carImages.find(c => c.illustratorId === 1)?.url;
        }
        if (!url) {
          url = defaultImage;
        }
        return url;
      }
      return;
    },
    editItem(item) {
      console.log("edit item");
      const auction = this.externalCar.find(a => a.id === item.id);
      const disabled = isEndedCar(auction) && !this.canRestart(auction);
      this.$modals.open(ModalType.EditMarketplaceModal, {
        ...auction,
        disabled: disabled
      });
    },
    clearCheckboxes() {
      this.checkedRows = [];
      this.canRestartRows = [];
    },
    checkRestartRows() {
      const canRestartRows = this.externalCar.filter(a => this.canRestart(a));
      this.checkRows(canRestartRows, "auction-manager__row-restart");
    },
    getStatus(auction) {
      return getStatus(auction);
    },
    getColor(status) {
      return getStatusColor(status);
    },
    getLastBid(auction) {
      return getLastCarBid(auction);
    },
    getLink(auction) {
      const status = this.getStatus(auction);
      if (status !== CAR_STATUS.Ended && status !== CAR_STATUS.Progress) {
        return "";
      }
      return `${URLS.app}${getAuctionLink(auction)}`;
    },
    toggleAll() {
      if (this.checkedRows.length) {
        this.checkedRows = [];
      } else {
        this.checkedRows = [...this.computedItems];
      }
    },
    toggleRow(item, index, columName, event) {
      console.log("toggleRow");
      if (
        this.checkedRows &&
        this.checkedRows.includes(item) &&
        event.path &&
        event.path.some(el => el?.classList?.contains("toggler"))
      )
        return;

      if (this.isChecked[item.id]) {
        this.checkedRows = [];
      } else {
        this.checkedRows = [item];
      }
    },
    checkCarTimer(item) {
      const changeStatus = (time, timerId, status, restartCheck = false) => {
        if (time >= 0) {
          clearTimeout(timerId);
          item.status = status;
          if (restartCheck) {
            this.checkCarTimer(item);
          }
        }
      };
      if (item.status === CAR_STATUS.Awaiting) {
        getTimerFromNowToDate(item.startDate, (time, timerId) =>
          changeStatus(time, timerId, CAR_STATUS.Progress, true)
        );
      } else {
        getTimerFromNowToDate(item.endDate, (time, timerId) =>
          changeStatus(time, timerId, CAR_STATUS.Ended)
        );
      }
    },
    async loadData() {
      this.loading = true;
      await this[marketplaceStore.actionTypes.GET_DATA]({
        take: this.$route.query.take || 10,
        skip: this.$route.query.skip || 0,
        search: this.$route.query.search,
        status: 3,
        all: true
      });
      this.loading = false;

      this.checkRestartRows();
    },
    onInputSearch(value) {
      this.searchFn(value);
    },
    canRestart(auction) {
      return (
        isEndedCar(auction) &&
        (isReversePriceNotMeet(auction) || isZeroBids(auction))
      );
    },
    checkRows(rows, rowClass) {
      if (!this.$refs.table) return;
      const rowsSelector = rows
        .reduce((acc, item) => `[data-row-id="${item.id}"],` + acc, "")
        .replace(/,$/, "");
      const rowsEl =
        rowsSelector.length > 0
          ? this.$refs.table.$el.querySelectorAll(rowsSelector)
          : [];

      const allRowsSelector = this.computedItems
        .reduce((acc, item) => `[data-row-id="${item.id}"],` + acc, "")
        .replace(/,$/, "");
      const allRowsEl =
        allRowsSelector.length > 0
          ? this.$refs.table.$el.querySelectorAll(allRowsSelector)
          : [];

      Array.from(allRowsEl).forEach(row => {
        if (row.parentNode.nodeName === "TR") {
          toggleRowClass(row.parentNode, rowClass, false);
        }
      });

      Array.from(rowsEl).forEach(row => {
        if (row.parentNode.nodeName === "TR") {
          toggleRowClass(row.parentNode, rowClass);
        }
      });
    },
    onChangeCheckBoxInput($event) {
      console.log("onChangeCheckBoxInput", $event.target.id);
      this[auctionManagerStore.actionTypes.ACTION_CAR_FEATURED]({
        id: Number($event.target.id),
        featured: $event.target.checked,
        route: this.$route
      });
      // alert("test", $event?.target?.checked)
    },
    onChangeTestCheckBoxInput($event) {
      console.log("onChangeCheckBoxInput", $event.target.id);
      this[carManagerStore.actionTypes.ACTION_TEST_MODE_CAR]({
        id: Number($event.target.id),
        isTestMode: $event.target.checked
      });
      // alert("test", $event?.target?.checked)
    }
  }
};
</script>
